import { DateTime } from "luxon";
import type { PickUpBranch } from "../schema/PickUpBranch.js";
import type { ScheduledB2cOrderStopSettingItem } from "../schema/ScheduledB2cOrderStopsSetting.js";
import { dateTimeZone } from "../schema/dateTimeZone.js";

export function isDateDuringScheduledB2cOrderStop(
	date: string,
	pickUpBranch: PickUpBranch | undefined,
	scheduledB2cOrderStops: ScheduledB2cOrderStopSettingItem[],
): boolean {
	const deliveryDate = DateTime.fromISO(date).setZone(dateTimeZone);
	return scheduledB2cOrderStops.some(
		({ branch, from, to }: ScheduledB2cOrderStopSettingItem) =>
			branch === pickUpBranch &&
			DateTime.fromISO(from).setZone(dateTimeZone) <= deliveryDate &&
			deliveryDate <= DateTime.fromISO(to).setZone(dateTimeZone),
	);
}
